export default "__VITE_ASSET__BDPhJv9I__"